//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import { gotoUrl } from '@/utils/util';
import { mapGetters } from 'vuex';
export default {
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger,
  },
  props: {
    hamburgerActive: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters('user', ['getTenantInfo', 'getUserInfo']), // user 模块名称
  },
  methods: {
    toggleSideBar() {
      this.$emit('toggleSideBar', !this.hamburgerActive);
    },
    freshSessionStorage() {
      sessionStorage.removeItem('userinfo-ams');
      this.$cookies.set('uin', '');
      this.$cookies.set('saas_token', '');
      gotoUrl('/login', { replace: true, href: true });
    },
  },
};
